// client/src/pages/Settings.tsx

import React from "react";
import { useAuth } from "../contexts/AuthContext";
import "../assets/styles/pages.css";

const Settings: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="page settings-page">
      <h2>Settings</h2>
      {user ? (
        <div>
          <p>User: {user.name || user.email}</p>
          {/* Additional settings controls can be placed here */}
        </div>
      ) : (
        <p>No user data available.</p>
      )}
    </div>
  );
};

export default Settings;
